import React, { forwardRef, useState } from 'react';
import './FaqAccordian.css';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const Faq = forwardRef(({ id, title, content }, ref) => {
  const [expanded, setExpanded] = useState(false);
  const handleChange = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <Accordion expanded={expanded} onChange={handleChange} disableGutters ref={ref}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls={`${id}-content`}
        id={`${id}-header`}
        sx={{ margin: 0 }}>
        <Typography fontFamily="gothamBold" fontSize={{ xs: 12, md: 18 }} color="#000000">
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ display: 'grid', gap: { md: '16px' } }}>
        {content &&
          content.map((paragraph, index) => (
            <Typography
              key={index}
              fontFamily="gothamBook"
              fontSize={14}
              lineHeight="24px"
              color="#00000099">
              {paragraph}
            </Typography>
          ))}
      </AccordionDetails>
    </Accordion>
  );
});

Faq.displayName = 'Faq';

export default Faq;
